import styled from "styled-components";
import { Row, Col, Button } from "react-bootstrap";
import { MainImage, MainImageMobile } from "../../Utils/ImageImportFile";
import useWindowMediaQuery from "../../../Hooks/MediaQuery";

export const WhatWeDoSection = () => {
	const screen = useWindowMediaQuery();
	return (
		<WhatWeDoStyled screen={screen}>
			<Col md={5} className="order-md-0 order-1">
				<Box screen={screen}>
					<h6>Services</h6>
					<h3>What We Do</h3>

					{!screen.md && (
						<img src={screen.xl ? MainImage : MainImageMobile} alt="" />
					)}

					<p>
						More than a web app development company; Explorator is a trusted partner
						that helps you catapult your business by designing experiences that
						accelerate growth.
					</p>
					<ButtonStyled screen={screen} variant="dark" href="/contact" rel="noopener noreferrer" >
						Contact Us
					</ButtonStyled>
				</Box>
			</Col>
			{screen.md && (
				<Col
					md={7}
					className={`${screen.xl ? "text-center" : "text-end"} order-md-1 order-0`}>
					<img src={screen.xl ? MainImage : MainImageMobile} alt="" />
				</Col>
			)}
		</WhatWeDoStyled>
	);
};

const WhatWeDoStyled = styled(Row)`
	justify-content: space-between;

	h6 {
		font-weight: normal;
		font-size: ${({ screen }) => (screen.md ? "24px" : "18px")};
		line-height: ${({ screen }) => (screen.md ? "32px" : "24px")};
		color: var(--bs-primary);
	}

	h3 {
		font-weight: bold;
		font-size: ${({ screen }) =>
			screen.xl ? "56px" : screen.md ? "34px" : "24px"};
		line-height: ${({ screen }) =>
			screen.xl ? "66px" : screen.md ? "42px" : "32px"};
		color: var(--bs-primary);
		margin-bottom: ${({ screen }) => (screen.md ? "35px" : "20px")};
	}

	p {
		font-size: 16px;
		line-height: 28px;
		color: var(--bs-primary);
	}

	img {
		width: ${({ screen }) =>
			screen.xl ? "inherit" : screen.md ? "400px" : "342px"};
		min-height: ${({ screen }) =>
			screen.xl ? "unset" : screen.md ? "500px" : "408px"};
		margin-bottom: ${({ screen }) => (screen.md ? "unset" : "20px")};
	}
`;

const Box = styled.div`
	margin-top: 35px;
`;

const ButtonStyled = styled(Button)`
	&.btn {
		margin-left: auto;
		margin-top: ${({ screen }) => (screen.md ? "40px" : "10px")};
		border-radius: 50px;
		width: 140px;
		height: 46px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--bs-gray-100);
		font-weight: 500;
		font-size: 14px;
		line-height: 24px;
		color: var(--bs-secondary);
		border-color: var(--bs-gray-100);

		.material-icons {
			margin-left: 10px;
		}
	}
`;
